export function formatNumberWithCommas(value) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(String(value).replace(/,/g, ''));
  if (!Number.isFinite(num)) return String(value);
  return num.toLocaleString('ko-KR');
}

export function generateTempTravelerId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  return (
    `${s4()}${s4()}-${s4()}-4${s4().substr(0, 3)}-${((8 + Math.random() * 4) | 0).toString(16)}${s4().substr(0, 3)}-${s4()}${s4()}${s4()}`
  );
}

function getNewlyAddedStorageKey(saleNo) {
  return `reservation:newlyAdded:${saleNo}`;
}

export function loadNewlyAddedIds(saleNo) {
  try {
    const raw = localStorage.getItem(getNewlyAddedStorageKey(saleNo));
    const arr = raw ? JSON.parse(raw) : [];
    return new Set((Array.isArray(arr) ? arr : []).map((x) => String(x)));
  } catch {
    return new Set();
  }
}

export function saveNewlyAddedIds(saleNo, idSet) {
  try {
    const arr = Array.from(idSet || []).map((x) => String(x));
    localStorage.setItem(getNewlyAddedStorageKey(saleNo), JSON.stringify(arr));
  } catch {
    /* ignore */
  }
}

export function normalizeAgeValue(val) {
  return String(val ?? '').trim();
}

export function buildAgeArrayFromTravelers(list) {
  const ages = (Array.isArray(list) ? list : [])
    .map((t) => normalizeAgeValue(t?.연령구분))
    .filter((s) => /^\d+$/.test(s))
    .map((s) => Number(s))
    .filter((n) => Number.isFinite(n) && n >= 0)
    .sort((a, b) => a - b);
  return ages.join(',');
}

export function buildAdultCountFromTravelers(list) {
  return (Array.isArray(list) ? list : []).filter((t) => {
    const age = normalizeAgeValue(t?.연령구분);
    if (!age) return true;
    if (age.includes('성인')) return true;
    return !/^\d+$/.test(age);
  }).length;
}

export async function mergeTravelersWithRctPassport({ saleNo, list, getReservationTravelerListBySaleNo, getCustomerListBySaleNoFromRCT }) {
  const withKeys = (Array.isArray(list) ? list : []).map((r, idx) => ({
    ...r,
    key: String(r?.여행객키 || r?.여행객번호 || idx),
  }));
  try {
    const rctList = await getCustomerListBySaleNoFromRCT({ saleNo });
    const byTravelerNo = new Map();
    (Array.isArray(rctList) ? rctList : []).forEach((row) => {
      const no = Number(row?.여행객번호);
      if (Number.isFinite(no) && no > 0) byTravelerNo.set(no, row);
    });
    return withKeys.map((row) => {
      const no = Number(row?.여행객번호 || row?.여행객키);
      const rctRow = Number.isFinite(no) && no > 0 ? byTravelerNo.get(no) : null;
      if (rctRow?.여권사본경로) {
        return { ...row, 여권사본경로: rctRow.여권사본경로 };
      }
      return row;
    });
  } catch {
    return withKeys;
  }
}
